// routes
import { PATH_DASHBOARD } from "../../../routes/paths";

import SvgColor from "../../../components/svg-color";
// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  dashboard: icon("dashboard_ic"),
  classes: icon("classes_ic"),
  divisions: icon("classes_ic"),
  students: icon("student_ic"),
  subjects: icon("subject_ic"),
  teachers: icon("users_ic"),
  families: icon("users_ic"),
  ads: icon("ads_ic"),
  ministerial_decisions:icon("ads_ic"),
  profile: icon("profile_ic"),
  contact: icon("contact_us_ic"),
};

const navConfig = [
  // Admin
  // ----------------------------------------------------------------------
  {
    subheader: "manager",
    title: "dashboard",
    icon: ICONS.dashboard,
    path: "/overview",
  },
  {
    subheader: "manager",
    title: "educational_institution",
    icon: ICONS.classes,
    path: "/educational_institution",
  },
  {
    subheader: "manager",
    title: "subjects",
    icon: ICONS.subjects,
    path: "/subjects",
  },
  {
    subheader: "manager",
    title: "students",
    icon: ICONS.students,
    path: "/students",
  },
  {
    subheader: "manager",
    title: "teachers",
    icon: ICONS.teachers,
    path: "/teachers",
  },
  {
    subheader: "manager",
    title: "ads",
    icon: ICONS.ads,
    path: "/ads",
  },
  {
    subheader: "manager",
    title: "ministerial_decisions",
    icon: ICONS.ministerial_decisions,
    path: "/ministerial_decisions",
  },
  {
    subheader: "manager",
    title: "samples",
    icon: ICONS.ministerial_decisions,
    path: "/samples",
  },
  {
    subheader: "manager",
    title: "my_profile",
    icon: ICONS.profile,
    path: "/profile",
  },
  {
    subheader: "manager",
    title: "contact_us",
    icon: ICONS.contact,
    path: "/contact-us",
  },
];

export default navConfig;
